import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaComisionistasGrafica', {
    template: template,
    controller: NominaComisionistasGraficaComponent,
    bindings: {
      data: '<',
    },
  })

function NominaComisionistasGraficaComponent() {
  let $ctrl = this

  $ctrl.$onChanges = $onChanges

  function $onChanges(changes) {
    if (changes.data) {
      $ctrl.grafica = {
        labels: [],
        data: [],
        colours: [],
      }

      $ctrl.data.forEach(function (item) {
        $ctrl.grafica.labels.push(item.comisionista)
        $ctrl.grafica.data.push(item.comision_importe)
        $ctrl.grafica.colours.push(item.color)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/comisionistas/grafica/component.js